<template>
  <fragment v-if="$store.getters.isInRole('stats-import')">
  <div class="row">
      <div class="col-12">
        <div class="card m-b-30">
          <div class="card-body">
    <div class="row">
      
      <div class="col-6">
           <select v-model="agency" class="form-control">
<option value="cdl">CDL</option>
<option value="rgstampa">RG Stampa</option>

        </select>
        <vue-dropzone
          ref="myVueDropzone"
          id="attachment-dropzone"
          name="attachment-dropzone"
          :maxFile=1
          :options="dropzoneOptions()"
          :useCustomSlot="true"
        >
          <div class="dropzone-custom-content">
            <h3 class="dropzone-custom-title">
              Trascina il file <strong>{{extensions[agency]}}</strong> qui per il caricamento
            </h3>
            <div class="subtitle">...o fai click per caricarlo dal tuo pc</div>
          </div>
        </vue-dropzone>
      </div>
        <div class="col-6 mt-3">
        <FullCalendar :options="calendarOptions" />
    </div>
    </div>
 
          </div>
        </div>
      
      </div>
    <a ref="attachmentA"></a>
 
  </div>
  
  </fragment>
</template>
<style scoped>
.attachment-filename {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<script>
let vm_scope;
import axios from "axios";
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'

import itLocale from '@fullcalendar/core/locales/it';
export default {
  name: "kiosk",

  props: {
 
  },
  components: {
FullCalendar

  },
  data() {
    return {
      calendarEvents:[],
      agency: "rgstampa",
      extensions:{
"rgstampa":".csv",
"cdl":".xlsx"

      },
       calendarOptions: {
         events: this.events,
         locale:"it",
        plugins: [ dayGridPlugin, interactionPlugin ],
        initialView: 'dayGridMonth',
      headerToolbar:  {
  start: 'prev,today,next', // will normally be on the left. if RTL, will be on the right
  center: 'title',
  end: 'dayGridMonth,dayGridWeek' // will normally be on the right. if RTL, will be on the left
}
      }
    };
  },
  mounted() {
    
  },
  methods: {

    events:function(info, successCallback, failureCallback){
      axios.get(`kiosk/import/calendar?start=${info.startStr.substring(0, 10)}&end=${info.endStr.substring(0, 10)}`).then((response)=>{
successCallback(response.data);

      });

    },
    getExtensionIcon: function (ext) {
      if (ext) ext = ext.toLowerCase();
      else ext = "";
      switch (ext) {
        case ".txt":
          return "fa fa-file-text-o";
        case ".doc":
        case ".docx":
          return "fa fa-file-word-o  text-info";
        case ".xls":
        case ".xlsx":
        case ".csv":
          return "fa fa-file-excel-o text-success";
        case ".jpg":
        case ".jpeg":
        case ".png":
        case ".bmp":
        case ".tiff":
          return "fa fa-image-o  text-info";
        case ".pdf":
          return "fa fa-file-pdf-o text-danger";
        case ".wav":
        case ".mp3":
          return "fa fa-file-audio-o text-warning";
        case ".ppt":
        case ".pptx":
          return "fa fa-file-powerpoint-o text-warning";
        case ".zip":
        case ".rar":
        case ".7z":
          return "fa fa-file-archive-o  text-warning";
        default:
          return "fa fa-file-o";
      }
    },
    dropzoneOptions: function () {
      var me = this;
      vm_scope = this;
      function url() {
        return (
          window.SETTINGS.apiUrl +
          "/kiosk/" +
          me.agency 
        );
      }
      return {
        url: url,
        headers: { Authorization: "Bearer " + this.$store.state.user.token },
        success: function (a, b) {
          this.removeFile(a);
         
        },
      };
    },

  },
};
</script>
